var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotApplicable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2406_65147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 20C16.3589 20 20.8359 15.523 20.8359 10C20.8359 4.477 16.3589 0 10.8359 0C5.31294 0 0.835938 4.477 0.835938 10C0.835938 15.523 5.31294 20 10.8359 20Z",
    fill: "#B7C4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83594 10L14.8359 10.0002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2406_65147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotApplicable);
export default __webpack_public_path__ + "static/media/notApplicable.c300285efd86fcbed83c773172aafb9e.svg";
export { ForwardRef as ReactComponent };